'use strict';

const gtmHelpers = require('../helpers/gtm');

/**
 * Update DOM elements with Ajax results
 *
 * @param {Object} $results - jQuery DOM element
 * @param {string} selector - DOM element to look up in the $results
 * @return {undefined}
 */
function updateDom($results, selector) {
  var $updates = $results.find(selector);
  $(selector).empty().html($updates.html());
  initSliders();
  initDateRanges();
}

/**
 * Keep refinement panes expanded/collapsed after Ajax refresh
 *
 * @param {Object} $results - jQuery DOM element
 * @return {undefined}
 */
function handleRefinements($results) {
  $('.refinement.active').each(function () {
    $(this).removeClass('active');
    var activeDiv = $results.find('.' + $(this)[0].className.replace(/ /g, '.'));
    activeDiv.addClass('active');
    activeDiv.find('button.title').attr('aria-expanded', 'true');
  });

  updateDom($results, '.refinements');
}

/**
 * Parse Ajax results and updated select DOM elements
 *
 * @param {string} response - Ajax response HTML code
 * @return {undefined}
 */
function parseResults(response) {
  var $results = $(response);
  var specialHandlers = {
    '.refinements': handleRefinements
  };

  // Update DOM elements that do not require special handling
  [
    '.grid-header',
    '.header-bar',
    '.header.page-title',
    '.product-grid',
    '.show-more',
    '.filter-bar'
  ].forEach(function (selector) {
    updateDom($results, selector);
  });

  Object.keys(specialHandlers).forEach(function (selector) {
    specialHandlers[selector]($results);
  });
}

/**
 * This function retrieves another page of content to display in the content search grid
 * @param {JQuery} $element - the jquery element that has the click event attached
 * @param {JQuery} $target - the jquery element that will receive the response
 * @return {undefined}
 */
function getContent($element, $target) {
  var showMoreUrl = $element.data('url');
  $.spinner().start();
  $.ajax({
    url: showMoreUrl,
    method: 'GET',
    success: function (response) {
      $target.append(response);
      $.spinner().stop();
    },
    error: function () {
      $.spinner().stop();
    }
  });
}

/**
 * Update sort option URLs from Ajax response
 *
 * @param {string} response - Ajax response HTML code
 * @return {undefined}
 */
function updateSortOptions(response) {
  var $tempDom = $('<div>').append($(response));
  var sortOptions = $tempDom.find('.grid-footer').data('sort-options').options;
  sortOptions.forEach(function (option) {
    $('a.' + option.id).data('value', option.url);
  });
}

function setDefaultDate() {
  const mindate = $('.input-daterange').data('mindate');
  const maxdate = $('.input-daterange').data('maxdate');
  window.datesCache = window.datesCache || {};
  if (mindate != null && mindate != '01/01/1970') {
    $('.startDate').val(mindate);
  }
  if (maxdate != null && maxdate != '01/19/2038') {
    $('.endDate').val(maxdate);
  }
}

function updateURLDateParams(startDate, endDate, dateRange) {
  const formattedStartDate = Math.floor(new Date(startDate).getTime() / 1000);
  const formattedEndDate = Math.floor(new Date(endDate).getTime() / 1000);
  const currentUrl = new URL(dateRange.parents('div.input-daterange').data('href'), window.location.href);
  const prefIndex = Array.from(currentUrl.searchParams.keys).filter(key => key.startsWith('prefn')).length + 1;
  currentUrl.searchParams.set('prefn' + prefIndex, 'date');
  currentUrl.searchParams.delete('prefv' + prefIndex);

  if (startDate && endDate) {
    currentUrl.searchParams.set('prefmin' + prefIndex, formattedStartDate);
    currentUrl.searchParams.set('prefmax' + prefIndex, formattedEndDate);
  } else if (startDate && !endDate) {
    currentUrl.searchParams.set('prefmin' + prefIndex, formattedStartDate);
    currentUrl.searchParams.set('prefmax' + prefIndex, '2147483647');
  } else if (endDate && !startDate) {
    currentUrl.searchParams.set('prefmin' + prefIndex, '0000000000');
    currentUrl.searchParams.set('prefmax' + prefIndex, formattedEndDate);
  }

  dateRange.parents('div.input-daterange').attr('data-href', currentUrl);
}

function handleDateChange(dateRange) {
  var startDate;
  var endDate;
  if (dateRange.hasClass('startDate')) {
    startDate = dateRange.val();
    endDate = dateRange.parent().siblings().children('input').val();
  }
  if (dateRange.hasClass('endDate')) {
    endDate = dateRange.val();
    startDate = dateRange.parent().siblings().children('input').val();
  }
  window.datesCache = {
    startDate,
    endDate
  };
  dateRange.datepicker('hide');
  updateURLDateParams(startDate, endDate, dateRange);

  if (startDate) {
    dateRange.datepicker('setStartDate', startDate);
    $('.startDate').val(startDate);
  }

  if (endDate) {
    dateRange.datepicker('setEndDate', endDate);
    $('.endDate').val(endDate);
  }
}

function initDateRanges() {
  setDefaultDate();

  $('.input-daterange input').each(function () {
    const dateRange = $(this);
    dateRange.datepicker({
      format: 'mm/dd/yyyy'
    });
    dateRange.datepicker()
      .on('changeDate', function (e) {
        handleDateChange(dateRange);
      });
  });

  $('.container-fluid').on('click', 'button.reset', () => {
    window.datesCache = {};
  });
}

function updateSliderCache(data, sliderRange, sliderId) {
  window.sliderCache[sliderId].dataFrom = data.from;
  window.sliderCache[sliderId].dataTo = data.to;
  sliderRange.attr("data-from", data.from).attr("data-to", data.to);
}

function updateURLSliderParams(data, sliderRange, isPriceSlider) {
  const currentUrlNew = new URL(window.location.href);
  var ajaxUrl = currentUrlNew.protocol + "//" + currentUrlNew.hostname + ($('.ajaxUrlPrice').attr('data-href'));
  const currentUrl = new URL(ajaxUrl);

  // Check if srule parameter exists in currentUrlNew and preserve it
  if (currentUrlNew.searchParams.has('srule')) {
    let sruleValue = currentUrlNew.searchParams.get('srule');
    currentUrl.searchParams.set('srule', sruleValue);
  }

  if (isPriceSlider) {
    currentUrl.searchParams.set('pmin', data.from);
    currentUrl.searchParams.set('pmax', data.to);
    sliderRange.parent().attr('data-href', currentUrl);
  } else {
    const prefIndex = Array.from(currentUrlNew.searchParams.keys()).filter(key => key.startsWith('prefn')).length;
    let found = false;
    //Set the new values from the data/sliderRange on the map
    for (let i = 1; i <= prefIndex; i++) {
      //if any ocurrence exist with the current "Refine" overwrite the params
      if ( currentUrl.searchParams.get(`prefn${i}`) === sliderRange.parent().data('refineby') ) {
        currentUrl.searchParams.set(`prefn${i}`, sliderRange.parent().data('refineby'));
        currentUrl.searchParams.set(`prefmin${i}`, data.from);
        currentUrl.searchParams.set(`prefmax${i}`, data.to);
        found = true;
        break;
      }
    }
    //if no ocurrence on the params, add the new parameter
    if(!found){
      let i = prefIndex+1;
      currentUrl.searchParams.set(`prefn${i}`, sliderRange.parent().data('refineby'));
      currentUrl.searchParams.set(`prefmin${i}`, data.from);
      currentUrl.searchParams.set(`prefmax${i}`, data.to);
    }
    sliderRange.parent().attr('data-href', currentUrl.href);
  }
}

function initSliders() {
  window.sliderCache = window.sliderCache || {};
  require('ion-rangeslider');
  $('input[name="rangeslider"]').each(function () {
    const sliderRange = $(this);
    const sliderId = sliderRange.parent().data('refineby');
    const cachedValues = window.sliderCache[sliderId];
    if (!cachedValues) {
      window.sliderCache[sliderId] = {};
    }
    const isPriceSlider = sliderRange.parent().hasClass('price-slider');
    sliderRange.ionRangeSlider({
      type: "double",
      hide_min_max: true,
      from: window.sliderCache[sliderId].dataFrom ? window.sliderCache[sliderId].dataFrom : sliderRange.data('min'),
      to: window.sliderCache[sliderId].dataTo ? window.sliderCache[sliderId].dataTo : sliderRange.data('max'),
      prettify: function (value) {
        if (value % 1 === 0) {
          return value.toFixed(0);
        } else {
          return value.toFixed(2);
        }
      },
      onStart: function (data) {
        if (!cachedValues) {
          window.sliderCache[sliderId] = {};
          updateSliderCache(data, sliderRange, sliderId);
        } else {
          sliderRange.attr("data-from", cachedValues.dataFrom).attr("data-to", cachedValues.dataTo);
        }
      },
      onChange: function (data) {
        updateSliderCache(data, sliderRange, sliderId);
        updateURLSliderParams(data, sliderRange, isPriceSlider);
        $('.container-fluid').off('mouseup touchend');
      },
      onFinish: function (data) {
        const temp = $(data.slider[0]);
        $.spinner().start();
        const ajaxUrl = new URL(temp.parents('div[name=slider]').attr('data-href'), window.location.href);
        const currentUrl = new URL(window.location.href);
        currentUrl.search = ajaxUrl.search;
        currentUrl.searchParams.delete('cgid');
        currentUrl.searchParams.set('view', 'list');
        $.ajax({
          url: ajaxUrl.toString(),
          data: {
            page: $('.grid-footer').data('page-number'),
            selectedUrl: ajaxUrl.toString()
          },
          method: 'GET',
          success: function (response) {
            window.history.pushState({ action: 'slider', ajaxUrl: ajaxUrl.toString() }, '', currentUrl);
            parseResults(response);
            $.spinner().stop();
          },
          error: function () {
            $.spinner().stop();
          }
        })
      }
    });
    $('.container-fluid').on('click', 'button.reset', () => {
      window.sliderCache = {};
    });
  });
}

module.exports = {

  sort: function () {
    // Handle sort order menu selection
    $('.container-fluid').on('click', '#sortingDropdown > a', function (e) {
      e.stopPropagation();
      e.preventDefault();

      $.spinner().start();
      $('#sortingDropdown').collapse('toggle');
      const dataValue = new URL($(this).attr('data-value'));
      const optionName = $(this).data('name');
      const sortingButton = $('#sortingButton');
      sortingButton.find('.sortingName').text('Sort: ' + optionName);
      $(this).trigger('search:sort', dataValue.toString());
      const srule = dataValue.searchParams.get('srule');
      var currentUrl = new URL(window.location.href);
      currentUrl.searchParams.set('srule', srule);
      $.ajax({
        url: dataValue.toString(),
        data: {
          selectedUrl: dataValue.toString()
        },
        method: 'GET',
        success: function (response) {
          window.history.pushState({ action: 'sort', ajaxUrl: dataValue.toString() }, '', currentUrl);
          $('.product-grid').empty().html(response);
          $('#search-count').text($('#dynamic-search-count').text() + ' Results');
          $('#search-result-count').text($('#dynamic-search-count').text() + ' Results for');
          $.spinner().stop();
        },
        error: function () {
          $.spinner().stop();
        }
      });
    });
  },

  showMore: function () {
    // Show more products
    $('.container-fluid').on('click', '.show-more button', function (e) {
      e.stopPropagation();
      e.preventDefault();
      const showMoreUrl = new URL($(this).data('url'));

      $.spinner().start();
      $(this).trigger('search:showMore', e);

      const currentUrl = new URL(window.location.href);
      const startVal = showMoreUrl.searchParams.get('start');
      const szVal = showMoreUrl.searchParams.get('sz');
      currentUrl.searchParams.set('start', startVal);
      currentUrl.searchParams.set('sz', szVal);

      $.ajax({
        url: showMoreUrl.toString(),
        data: {
          selectedUrl: showMoreUrl.toString()
        },
        method: 'GET',
        success: function (response) {
          window.history.pushState({ action: 'showMore', ajaxUrl: showMoreUrl.toString() }, '', currentUrl);
          $('.top-paging').remove();
          $('.col-12.col-sm-6.col-lg-4.mb-4').remove();
          $('.grid-footer').replaceWith(response);
          $('#page-results')[0].scrollIntoView(true);
          updateSortOptions(response);
          $.spinner().stop();
        },
        error: function () {
          $.spinner().stop();
        }
      });
    });
  },
  applyFilter: function () {
    // Handle refinement value selection and reset click
    $('.container-fluid').on(
      'click',
      '.refinements li button, .refinement-bar button.reset, button.reset, .filter-value button, .swatch-filter button',
      function (e) {
        e.preventDefault();
        e.stopPropagation();

        $.spinner().start();

        var attributeId = '#' + $(this).find('span').last().attr('id');
        const ajaxUrl = new URL($(this).data('href'), window.location.origin);
        const rootUrl = $(this).data('root-url');
        const currentUrl = new URL(rootUrl ? rootUrl : window.location.href);

        currentUrl.search = ajaxUrl.search;
        currentUrl.searchParams.delete('cgid');
        currentUrl.searchParams.set('view', 'list');

        $.ajax({
          url: ajaxUrl.toString(),
          data: {
            page: $('.grid-footer').data('page-number'),
            selectedUrl: ajaxUrl.toString()
          },
          method: 'GET',
          success: function (response) {
            window.history.pushState({ action: 'applyFilter', ajaxUrl: ajaxUrl.toString() }, '', currentUrl);
            parseResults(response);
            $.spinner().stop();
            $(attributeId).parent('button').focus();
          },
          error: function () {
            $.spinner().stop();
            $(attributeId).parent('button').focus();
          }
        });
      });

    $('.container-fluid').on('mousedown touchstart', 'span.irs-handle', function () {
      var temp = $(this);
      if ($('.container-fluid').on('mouseup touchend', function (e) {

        e.preventDefault();
        e.stopPropagation();

        $.spinner().start();
        temp.trigger('search:filter', e);
        const ajaxUrl = new URL(temp.parents('div[name=slider]').attr('data-href'), window.location.href);
        const currentUrl = new URL(window.location.href);
        currentUrl.search = ajaxUrl.search;
        currentUrl.searchParams.delete('cgid');
        currentUrl.searchParams.set('view', 'list');

        $.ajax({
          url: ajaxUrl.toString(),
          data: {
            page: $('.grid-footer').data('page-number'),
            selectedUrl: ajaxUrl.toString()
          },
          method: 'GET',
          success: function (response) {
            window.history.pushState({ ajaxUrl: ajaxUrl.toString() }, '', currentUrl);
            parseResults(response);
            $.spinner().stop();
          },
          error: function () {
            $.spinner().stop();
          }
        })
        $('.container-fluid').off('mouseup touchend');
      }));
    });

    $('.container-fluid').on('change', '.startDate, .endDate', function (e) {
      e.preventDefault();
      e.stopPropagation();

      $.spinner().start();
      $(this).trigger('search:filter', e);
      const ajaxUrl = new URL($(this).parents('div.input-daterange').attr('data-href'));
      const currentUrl = new URL(window.location.href);
      currentUrl.search = ajaxUrl.search;
      currentUrl.searchParams.delete('cgid');
      currentUrl.searchParams.set('view', 'list');

      $.ajax({
        url: ajaxUrl.toString(),
        data: {
          page: $('.grid-footer').data('page-number'),
          selectedUrl: ajaxUrl.toString()
        },
        method: 'GET',
        success: function (response) {
          window.history.pushState({ ajaxUrl: ajaxUrl.toString() }, '', currentUrl);
          parseResults(response);
          $.spinner().stop();
        },
        error: function () {
          $.spinner().stop();
        }
      });
    });
  },

  showContentTab: function () {
    // Display content results from the search
    $('.container-fluid').on('click', '.content-search', function () {
      if ($('#content-search-results').html() === '') {
        getContent($(this), $('#content-search-results'));
      }
    });

    // Display the next page of content results from the search
    $('.container-fluid').on('click', '.show-more-content button', function () {
      getContent($(this), $('#content-search-results'));
      $('.show-more-content').remove();
    });
  },

  initSliders: function () {
    initSliders();
    initDateRanges()
  },

  initProductClick: function () {
    $('.eventCard').off('click').on('click', 'button a', function () {
      const $eventCard = $(this).parents('.eventCard');
      const name = $eventCard.data('name');
      const id = $eventCard.data('id');
      const price = $eventCard.data('price');
      const primaryCategory = $eventCard.data('category');
      const categories = $eventCard.data('categories');

      gtmHelpers.onProductClick(name, id, price, primaryCategory, categories);
    })
  },

  initHistory: function () {
    const pageQuery = $('body > div.page').data('querystring');
    const cgid = pageQuery.split('&').find(p => p.startsWith('cgid'))?.split('=')[1];
    const ajaxUrl = new URL($('button.reset').data('href'), window.location.origin);
    ajaxUrl.search = window.location.search;
    ajaxUrl.searchParams.set('cgid', cgid);

    window.history.pushState({ ajaxUrl: ajaxUrl.toString() }, "", new URL(window.location));
    window.addEventListener('popstate', (ev) => {
      if(ev.state)
      {
        $.spinner().start();
        const { action, ajaxUrl: historyUrl } = ev.state;
        $.ajax({
          url: historyUrl,
          data: {
            page: $('.grid-footer').data('page-number'),
            selectedUrl: historyUrl
          },
          method: 'GET',
          success: function (response) {
            switch (action) {
              case "sort":
                $('.product-grid').empty().html(response);
                $('#search-count').text($('#dynamic-search-count').text() + ' Results');
                $('#search-result-count').text($('#dynamic-search-count').text() + ' Results for');
                break;
              case "showMore":
                $('.top-paging').remove();
                $('.col-12.col-sm-6.col-lg-4.mb-4').remove();
                $('.grid-footer').replaceWith(response);
                $('#page-results')[0].scrollIntoView(true);
                updateSortOptions(response);
                break;
              case "applyFilter":
              case "slider":
              default:
                parseResults(response);
            }
            $.spinner().stop();
          },
          error: function () {
            $.spinner().stop();
          }
        })
      }
    })
  }
};